module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent-app-icon-9.2ae62972.png";